<mat-dialog-content class="customer-dialog">
  <!-- Search Section -->
  <div class="search-container">
    <mat-form-field >
      <mat-label>Item Code</mat-label>
      <input matInput [(ngModel)]="itCode" (keyup)="retriveItems()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>Item Name</mat-label>
      <input matInput [(ngModel)]="itTName" (keyup)="retriveItems()">
    </mat-form-field>

  </div>

    <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
        <th style="width: 30%;">Item Code</th>
            <th style="width: 100%;">Item Name</th>
            <th style="width: 20%;">Choose</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of itemsList; let i = index">
            <td data-column="Item ID">{{item.itCode}}</td>
            <td data-column="Item Name">{{item.itTName}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectItem(item)">{{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </mat-dialog-content>

